import getSelectedTableView from './getSelectedTableView';
/**
 * Whether list view is currently showing search table
 * @return flag indicating whether list view is currently showing search table
 */
export default function getIsSearchTableShown() {
    var tableView = getSelectedTableView();
    // VSO 29875 tableView is null fileshub/photohub search boxes
    if (tableView) {
        return tableView.tableQuery.type === 1 /* Search */;
    }
    return false;
}
//# sourceMappingURL=getIsSearchTableShown.js.map